import { Link, Route, Routes } from 'react-router-dom';
import Products from './pages/Products';
import ProductDetail from './pages/ProductDetail';
import DeploymentTrace from './pages/DeploymentTrace';
import Components from './pages/Components';
import ComponentDetail from './pages/ComponentDetail';
import { ChatWidget } from './components/ChatWidget';

export default function App() {
  return (
    <div className="container mx-auto max-w-6xl p-6">
      <header className="mb-8 flex items-center justify-between">
        <Link to="/">
          <h1 className="text-3xl font-bold text-arcforge-700">Arcforge</h1>
        </Link>
        <nav className="space-x-4 text-sm">
          <Link to="/" className="text-arcforge-700 hover:text-arcforge-500">
            產品
          </Link>
          <Link
            to="/components"
            className="text-arcforge-700 hover:text-arcforge-500"
          >
            元件庫
          </Link>
        </nav>
      </header>
      <main>
        <Routes>
          <Route path="/" element={<Products />} />
          <Route path="/products/:id" element={<ProductDetail />} />
          <Route path="/deployments/:id" element={<DeploymentTrace />} />
          <Route path="/components" element={<Components />} />
          <Route path="/components/:id" element={<ComponentDetail />} />
          <Route path="*" element={<p>頁面不存在</p>} />
        </Routes>
      </main>
      <ChatWidget />
    </div>
  );
}
